import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../App.css";
import MedicationResources from "../MedicationResources";
import { nonInvasiveDevices } from "../data/nonInvasiveDevicesData";
import Disclaimer from "../components/Disclaimer";
import TopBar from "../components/TopBar"; // ← reusable header (breadcrumb + avatar/login + white nav + modals)

const NonInvasiveDevices = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParams = new URLSearchParams(location.search);
  const deviceFromSearch = queryParams.get("treatment");

  const defaultDevice = deviceFromSearch || Object.keys(nonInvasiveDevices)[0];
  const [showSidebar, setShowSidebar] = useState(false);
  const isMobile = typeof window !== "undefined" && window.innerWidth < 768;

  const [selectedDevice, setSelectedDevice] = useState(defaultDevice);
  const [selectedSummary, setSelectedSummary] = useState(null);
  const [showTreatmentSelector, setShowTreatmentSelector] = useState(true);

  useEffect(() => {
    if (deviceFromSearch && nonInvasiveDevices[deviceFromSearch]) {
      setSelectedDevice(deviceFromSearch);
    }
  }, [deviceFromSearch]);

  if (!nonInvasiveDevices[selectedDevice]) {
    return <h2>Error: Device not found.</h2>;
  }

  const { name, description, cost, insuranceCoverage, resources } =
    nonInvasiveDevices[selectedDevice];

  const handleViewSummary = (summary) => {
    setSelectedSummary(summary);
  };

  const handleCloseSummary = () => {
    setSelectedSummary(null);
  };

  return (
    <div className="page-container">
      {/* Reusable header (breadcrumb + account dropdown + white nav + modals) */}
      <TopBar breadcrumb={`Medical Devices > ${nonInvasiveDevices[selectedDevice]?.name}`} />

      <div className="medications-container">
        {isMobile && showTreatmentSelector && (
          <div className="treatment-selector-overlay">
            <div className="overlay-header">
              <button
                className="back-button"
                onClick={() => setShowTreatmentSelector(false)}
              >
                ← Back
              </button>
              <h2>Medical Devices</h2>
            </div>
            <div className="overlay-treatments">
              {Object.keys(nonInvasiveDevices).map((item) => (
                <div
                  key={item}
                  className={`category-card ${
                    selectedDevice === item ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedDevice(item);
                    navigate(`/non-invasive-devices?treatment=${encodeURIComponent(item)}`);
                    setShowTreatmentSelector(false);
                  }}
                >
                  <h3>{nonInvasiveDevices[item].name}</h3>
                </div>
              ))}
            </div>
          </div>
        )}

        {isMobile && !showTreatmentSelector && (
          <button
            className="select-treatment-button"
            onClick={() => setShowTreatmentSelector(true)}
          >
            Select a Treatment
          </button>
        )}

        <div className="medication-layout">
          {/* Sidebar */}
          <div className={`sidebar ${isMobile && showSidebar ? "open" : ""}`}>
            <h2 className="sidebar-title">Medical Devices</h2>
            <p className="sidebar-description">
              Explore devices commonly used for pain relief.
            </p>
            <div className="sidebar-blocks">
              {Object.keys(nonInvasiveDevices).map((device) => (
                <div
                  key={device}
                  className={`category-card ${
                    selectedDevice === device ? "active" : ""
                  }`}
                  onClick={() => {
                    setSelectedDevice(device);
                    navigate(`/non-invasive-devices?treatment=${encodeURIComponent(device)}`);
                    if (isMobile) setShowSidebar(false);
                  }}
                >
                  <h3>{nonInvasiveDevices[device].name}</h3>
                </div>
              ))}
            </div>
          </div>

          {/* Two-Box Layout */}
          <div className="main-content">
            <div className="medication-info-box">
              <h2 className="medication-title">{name}</h2>
              <p className="medication-description">{description}</p>
              {cost && (
                <p className="medication-info">
                  <strong>Cost:</strong> {cost}
                </p>
              )}
              {insuranceCoverage && (
                <p className="medication-info">
                  <strong>Insurance Coverage:</strong> {insuranceCoverage}
                </p>
              )}
            </div>

            <div className="research-box">
              <h3 className="resources-title">Research on Device Outcomes</h3>
              <MedicationResources
                resources={resources}
                onViewSummary={handleViewSummary}
              />
            </div>
          </div>
        </div>

        {selectedSummary && (
          <div className="summary-modal">
            <div className="modal-content">
              <button className="close-button" onClick={handleCloseSummary}>
                ×
              </button>
              <h3 style={{ textAlign: "left" }}>Summary</h3>
              <div className="summary-scroll">
                <p className="sidebar-description-left">{selectedSummary}</p>
              </div>
            </div>
          </div>
        )}
      </div>

      <Disclaimer />
    </div>
  );
};

export default NonInvasiveDevices;
